module.exports = __webpack_public_path__ + "images/bc977d2c792427a7a19ab1443252d556.webp";